class BBSPriceRange {
  constructor(root) {
    this.root = root;
    this.maxBound = Number(root.dataset.priceMax) || 100;
    this.minSlider = root.querySelector('[data-bbs-price-min-slider]');
    this.maxSlider = root.querySelector('[data-bbs-price-max-slider]');
    this.minInput = root.querySelector('[data-bbs-price-min]');
    this.maxInput = root.querySelector('[data-bbs-price-max]');
    this.label = root.closest('[data-bbs-filter-group]')?.querySelector('[data-bbs-price-label]');
    this.fill = root.querySelector('[data-bbs-price-fill]');
    this.minParam = root.dataset.minParam;
    this.maxParam = root.dataset.maxParam;
    this.form = root.closest('form');

    this.minSlider?.addEventListener('input', () => this.onInput());
    this.maxSlider?.addEventListener('input', () => this.onInput());
    this.form?.addEventListener('submit', () => this.syncHiddenInputs(true));

    this.onInput();
  }

  onInput() {
    let minVal = Number(this.minSlider.value);
    let maxVal = Number(this.maxSlider.value);

    if (minVal > maxVal) {
      if (document.activeElement === this.minSlider) {
        maxVal = minVal;
        this.maxSlider.value = maxVal;
      } else {
        minVal = maxVal;
        this.minSlider.value = minVal;
      }
    }

    if (this.label) {
      this.label.textContent = `£${minVal} - £${maxVal}`;
    }

    if (this.fill) {
      const left = (minVal / this.maxBound) * 100;
      const right = 100 - (maxVal / this.maxBound) * 100;
      this.fill.style.left = `${left}%`;
      this.fill.style.right = `${right}%`;
    }

    this.syncHiddenInputs(false);
  }

  syncHiddenInputs(forSubmit) {
    const minVal = Number(this.minSlider.value);
    const maxVal = Number(this.maxSlider.value);

    if (forSubmit) {
      if (minVal <= 0) {
        this.minInput.removeAttribute('name');
        this.minInput.value = '';
      } else {
        this.minInput.setAttribute('name', this.minParam);
        this.minInput.value = String(minVal);
      }

      if (maxVal >= this.maxBound) {
        this.maxInput.removeAttribute('name');
        this.maxInput.value = '';
      } else {
        this.maxInput.setAttribute('name', this.maxParam);
        this.maxInput.value = String(maxVal);
      }
      return;
    }

    this.minInput.value = minVal > 0 ? String(minVal) : '';
    this.maxInput.value = maxVal < this.maxBound ? String(maxVal) : '';
  }
}

function applyFilterColourSwatches() {
  const dataEl = document.querySelector('[data-bbs-colour-swatches]');
  if (!dataEl) return;

  let swatches = [];
  try {
    swatches = JSON.parse(dataEl.textContent);
  } catch (error) {
    console.error('BBS colour swatch JSON parse failed', error);
    return;
  }

  const styleByName = new Map(
    swatches.map((entry) => [entry.name.trim().toLowerCase(), entry.style])
  );

  document.querySelectorAll('[data-colour-name]').forEach((label) => {
    const colourName = label.dataset.colourName?.trim().toLowerCase();
    if (!colourName) return;

    const style = styleByName.get(colourName);
    if (style) {
      label.setAttribute('style', style);
    }
  });
}

window.BBSApplyFilterColourSwatches = applyFilterColourSwatches;

document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('BBSFacetFiltersForm');

  applyFilterColourSwatches();

  document.querySelectorAll('[data-bbs-price-range]').forEach((root) => {
    new BBSPriceRange(root);
  });

  document.querySelectorAll('[data-bbs-colour-input]').forEach((input) => {
    input.addEventListener('change', () => {
      const label = input.closest('.bbs-filters__swatch');
      if (label) label.classList.toggle('is-active', input.checked);
    });
  });

  const personalisedToggle = document.querySelector('[data-bbs-personalised-toggle]');
  const personalisedFilters = document.querySelectorAll('[data-bbs-personalised-filter]');
  if (personalisedToggle && personalisedFilters.length) {
    const syncPersonalised = () => {
      personalisedFilters.forEach((input) => {
        if (!personalisedToggle.checked) {
          input.removeAttribute('name');
        } else {
          input.setAttribute('name', input.dataset.filterName);
        }
      });
    };
    personalisedToggle.addEventListener('change', syncPersonalised);
    syncPersonalised();
    form?.addEventListener('submit', syncPersonalised);
  }

  if (form) {
    form.addEventListener('submit', () => {
      const favToggle = document.querySelector('[data-bbs-favourites-toggle]');
      if (favToggle?.checked) {
        sessionStorage.setItem('bbs-show-favourites', 'true');
      } else {
        sessionStorage.removeItem('bbs-show-favourites');
      }
    });
  }

  if (sessionStorage.getItem('bbs-show-favourites') === 'true') {
    const favToggle = document.querySelector('[data-bbs-favourites-toggle]');
    if (favToggle) {
      favToggle.checked = true;
      window.BBSFavourites?.filterGrid(true);
    }
  }

  const clearFilters = document.querySelector('[data-bbs-clear-filters]');
  if (clearFilters) {
    clearFilters.addEventListener('click', () => {
      sessionStorage.removeItem('bbs-show-favourites');
    });
  }
});
